import { lazy } from '@loadable/component';
import { WhatsappSettingsProps } from './WhatsappSettings.types';
import { Suspense } from 'react';
import { WhatsappSettingsLoading } from './WHatsappSettings.loading';
import { ErrorBoundary } from '@sentry/react';
import { ErrorFallback } from '../../patterns';

export const WhatsappSettingsLoadable = lazy(
  () => import('./WhatsappSettings')
);

export const WhatsappSettings = (props: WhatsappSettingsProps) => (
  <ErrorBoundary fallback={<ErrorFallback />}>
    <Suspense fallback={<WhatsappSettingsLoading />}>
      <WhatsappSettingsLoadable {...props} />
    </Suspense>
  </ErrorBoundary>
);
